<template>
  <vs-prompt class="large" title="إنشاء إعلان" :active="active" @close="close" buttons-hidden>
    <div class="w-full mb-4">
      <label>العنوان</label>
      <vs-input class="w-full" v-model="formData.title"
                v-validate="'required'" name="title" data-vv-as="العنوان"/>
      <span class="text-danger text-sm" v-show="errors.has('title')">{{ errors.first('title') }}</span>
    </div>
    <div class="w-full mb-4">
      <label>رسالة الإعلان</label>
      <textarea-autosize v-model="formData.message" v-validate="'required'" name="message" data-vv-as="رسالة الإعلان" />
      <span class="text-danger text-sm" v-show="errors.has('message')">{{ errors.first('message') }}</span>
    </div>
    <div class="w-full mb-4">
      <label>اختر المجموعات</label>
      <ul class="centerx flex flex-wrap">
        <li v-for="(group, index) in getCourseDetails.groups" :key="index">
          <vs-checkbox v-model="formData.groups" :vs-value="group.group"
                       v-validate="'required'" name="groups" data-vv-as="المجموعات" data-vv-validate-on="change">
            {{group.group}}
          </vs-checkbox>
        </li>
      </ul>
      <span class="text-danger text-sm" v-show="errors.has('groups')">يجب اختيار مجموعة واحده علي الاقل</span>
    </div>

    <div class="flex justify-end">
      <vs-button @click="close" type="flat">رجوع</vs-button>
      <vs-button @click="submit" class="ml-2">حفظ</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
    import announcementAPI from '@/api/announcementAPI'

    export default {
        name: 'announcementForm',
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                formData: { title: '', message: '', groups: [] }
            }
        },
        watch: {
            active(val) {
                if (!val) return
                this.intiValues()
            }
        },
        methods: {
            submit(){
                this.$validator.validateAll().then(result => {
                    if(result){
                        const announcementData = Object.assign({course_id: this.$route.params.course_id}, this.formData)
                        this.$startLoading()
                        announcementAPI.create(announcementData)
                            .then(({data}) => {
                                announcementData.id = data.id
                                this.$emit('save', announcementData)
                                this.close()
                            })
                            .catch(error => this.$notifyError(error.statusMessage))
                            .finally(() => this.$closeLoading())
                    }
                })
            },
            close() {
                this.$emit('update:active', false)
            },
            intiValues() {
                this.formData = { title: '', message: '', groups: [] }
            }
        }
    }
</script>
